import { FC, PropsWithChildren } from "react";
import { Page as CorePage, PageProps as CorePageProps } from "am-tax-fe-core";
import { useLocation } from "react-router-dom";

export type PageProps = PropsWithChildren<Omit<CorePageProps, "location" | "menuItems">>;

export const Page: FC<PageProps> = ({ children, ...pageProps }) => {
    const location = useLocation();

    return (
        <CorePage location={location} buildNumber={import.meta.env.VITE_BUILD_NUMBER} {...pageProps}>
            {children}
        </CorePage>
    );
};
